module.exports = __webpack_public_path__ + "static/media/youTube.0b8c3502.svg";